<template>
  <div class="mt-2 mx-0 px-0">
    <v-layout class="mx-0 px-0" row wrap v-if="list.length">
      <v-flex xs12 sm12>
        <v-container :class="[$vuetify.breakpoint.width > 959 ? 'ma-0 pa-0' : '']" grid-list-sm grid-list-md grid-list-lg>
          <v-layout justify-center row wrap>
            <v-flex
              v-for="(screener, index) in list"
              :key="screener.id"
              xs12
              sm6
              md3
              :class="[
                $vuetify.breakpoint.width < 959 && index >= 2
                  ? 'ma-0 pa-0'
                  : null,
              ]"
            >
              <template
                v-if="
                  ($vuetify.breakpoint.width < 959 && index < 2) ||
                    ($vuetify.breakpoint.width > 959 && index < 4)
                "
              >
                <ScreenerListItem :screener="screener"
                  :is_past="is_past"
                  :is_vod="is_vod"
                  @goToScreenerOverview="goToScreenerOverview"
                  @goToWatchPage="goToWatchPage"
                />
              </template>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PurchasedIndicator from "@/components/screener/PurchasedIndicator";
import { getSeatsStatus } from "@/mixins/screening";
import ScreenerListItem from "@/components/home/ScreenerListItem";

export default {
  name: "List",
  data() {
    return {
      dialog: false,
      screener: null,
      pricingPlan: null,
    };
  },
  props: {
    list: {
      default: null,
    },
    is_past: {
      type: Boolean,
      default: false,
    },
    is_vod: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PurchasedIndicator,
    ScreenerListItem
  },
  mixins: [getSeatsStatus],
  computed: {
    ...mapState({
      currentCompany: (state) => state.company.company,
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      isConsumerPurchased: "isPurchased",
      vodEventStartTime: "getVodEventStartTime",
      vodEventEndTime: "getVodEventEndTime",
      isVodEventExpired: "isVodEventExpired",
      isVodEventActive: "isVodEventActive",
    }),
    isArchiveMenu: function() {
      return this.$route.name == "screeners.archive";
    },
    eventPrefix() {
      return this.$route.name == "vod.movies" ? "vod" : "screener";
    },
  },
  methods: {
    goToScreenerOverview(screener_id) {
      this.$router.push({
        name: "screeners.overview",
        params: {
          screener_id: screener_id,
        },
      });
    },
    goToWatchPage(screener) {
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: screener.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.underline-on-hover:hover {
  border-bottom: 2px solid var(--v-secondary-base);
}
</style>
